import { useContext, createContext, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [error, setError] = useState(null);

  // const navigate = useNavigate();

  useEffect(() => {
    setUser({
      name: localStorage.getItem("name"),
      email: localStorage.getItem("email"),
    });
  }, []);

  const loginAction = async (data) => {
    try {
      setError(null);

      const res = await AuthService.login(data);
      if (res && res?.status == 1) {
        setUser({ name: res?.data?.name, email: res?.data?.email });
        setToken(res?.data?.token);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("email", res.data.email);
        localStorage.setItem("name", res.data.name);
        localStorage.setItem("userType", res.data.user_type);

        if (res.data.user_type == "2") {
          navigate("/dashboard");
          toast.success(t("You are Successfully Logged-In"));
        } else if (res.data.user_type == "3") {
          navigate("/dashboard");
          toast.success(t("You are Successfully Logged-In"));
        } else {
          toast.error(t("You are not authorized to access this page."));
          logOut();
        }

        // window.location.reload();
        return;
      } else {
        setError(t("Invalid Credentials"));
        return;
      }
    } catch (err) {
      console.log("ERROR", error);
      setError(t("Invalid Credentials"));
    }
  };

  const logOut = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem("token");
    // localStorage.removeItem("email");
    localStorage.removeItem("name");
    localStorage.removeItem("userType");
    toast.success(t("You are Successfully Logged-Out"));
    window.location.reload();
    // navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{ token, user, error, loginAction, logOut, setError }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
